import React from 'react';
import gundi_no_results from '../../images/gundi_no_results_green.png';

type NoResultsProps = {
  headerMsg: string;
  labelMsg: string | JSX.Element;
};

const NoResults = ({ headerMsg, labelMsg }: NoResultsProps) => {
  return (
    <div className="mx-auto">
      <img
        src={gundi_no_results}
        alt="empty results icon"
        className="mx-auto mb-6 h-[180px] cursor-auto"
      />
      <h2 className="mb-1 text-center text-xl transition-colors duration-300">
        {headerMsg}
      </h2>
      {/* Brand Text Secondary: on the card lists this sits straight on the page
                tint, and it stays readable on the near-white tables too. */}
      <h3 className="mb-4 text-center text-ui-text-secondary-text transition-colors duration-300">
        {labelMsg}
      </h3>
    </div>
  );
};

export default NoResults;
